<template>
    <div>
        <div class="profile-header" v-if="news_single && Object.keys(news_single).length > 0">
            <div class="relative">
                <div class="cover-container rounded-t-lg">
                    <img :src="news_single.translation[0].image_path" class="responsive block">
                </div>
            </div>
            <div class="flex items-center justify-end flex-wrap profile-header-nav pt15">

                <vs-tabs alignment="left">
                    <vs-tab :label="$t('Noticia')">
                        <vx-card>
                            <h2 class="mb5">{{news_single.translation[0].titulo}}</h2>
                            <h5 class="text-grey mb15">{{news_single.created_date}}</h5>

                            <QuillPresentInfo v-bind:info="news_single.translation[0].description" v-bind:cssClass="'mb15'">
                            </QuillPresentInfo>

                            <div class="videoContainer" v-if="news_single.translation[0].video_url">
                                <iframe class="video" width="100%" height="500" :src="news_single.translation[0].video_url" frameborder="0" allow="autoplay; encrypted-media; gyroscope;" allowfullscreen></iframe>
                            </div>

                            <div class="w-full mt15 mb10 flex flex-wrap">
                                <div class="w-1/3">
                                    <feather-icon icon="ThumbsUpIcon" class="iconLike mb15" @click="darLikeOuDislike('like')" v-if="news_single.vote.length == 0"></feather-icon>
                                    <feather-icon icon="ThumbsUpIcon" class="iconLike mb15" @click="darLikeOuDislike('like')" v-else :svgClasses="{'fill-current stroke-current': news_single.vote[0].news_vote_type_id == 1}"></feather-icon>
                                    <span class="font-bold nrLikeDislike mb15">{{news_single.likes}}</span>
                                    <br class="break">
                                    <feather-icon icon="ThumbsDownIcon" class="iconDislike" @click="darLikeOuDislike('dislike')" v-if="news_single.vote.length == 0"></feather-icon>
                                    <feather-icon icon="ThumbsDownIcon" class="iconDislike" @click="darLikeOuDislike('dislike')" v-else :svgClasses="{'fill-current stroke-current': news_single.vote[0].news_vote_type_id == 2}"></feather-icon>
                                    <span class="font-bold nrLikeDislike">{{news_single.dislikes}}</span>
                                </div>
                                <div class="w-2/3 float-right vx-col" v-if="news_single.translation[0].file.length > 0">
                                    <vx-tooltip :text="file.file_name" class="float-right" v-for="(file, index) in news_single.translation[0].file" :key="index">
                                            <vs-button icon-pack="feather" :href="file.file_path" target="_blank" radius icon="icon-file-text" class="ml-2 lg:ml-4 float-right mb5"></vs-button>
                                    </vx-tooltip>
                                </div>
                            </div>

                            <div class="vx-col w-full">
                                <!-- POST ACTION DATA -->
                                <div>
                                    <div class="comments-container mt-4">
                                        <ul class="user-comments-list" v-for="(com, index) in news_single.comments" :key="index">
                                            <li class="commented-user items-center mb-4">
                                                <div class="w-full flex">
                                                    <div class="mr-3"><vs-avatar class="m-0" src="" size="30px" /></div>
                                                    <div class="leading-tight">
                                                        <p class="font-medium">{{com.author.nome}}</p>
                                                        <span class="text-xs">{{com.comment_text}}</span>
                                                    </div>
                                                </div>
                                                <div class="w-full ml40" v-if="com.image_path">
                                                    <img class="comment_image" :src="com.image_path">
                                                </div>
                                            </li>
                                            <li class="commented-user flex items-center mb-4 respostaC" v-if="com.hasOwnProperty('reply')">
                                                <i class="vs-icon notranslate icon-scale vs-button--icon feather icon-corner-down-right text-grey mr5"></i>
                                                <div class="mr-3"><vs-avatar class="m-0" src="" size="30px" /></div>
                                                <div class="leading-tight">
                                                    <p class="font-medium">{{com.reply.author.nome}}</p>
                                                    <span class="text-xs">{{com.reply.comment_text}}</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="post-comment pb25">
                                        <vs-textarea v-model="comment_text" :label="user.name" :placeholder="$t('Comentario')" class="mb-2" />
                                        <vs-button class="float-left mr10" size="small" icon-pack="feather" icon="icon-send" v-on:click="sendC()">{{$t('Comentar')}}</vs-button>
                                        <div v-if="news_single.upload == 1">
                                            <vs-button class="float-left" size="small" icon-pack="feather" icon="icon-image" v-on:click="addFile()" v-if="upload_image.length == 0"></vs-button>
                                            <div class="chip_file" v-if="upload_image.length > 0">
                                                <vs-chip @click="removeFile()" closable color="primary" close-icon="close">
                                                    <vs-avatar :src="generateImgPath(upload_image[0])" text="Imagem"/>
                                                    {{ upload_image[0]['name'] }}
                                                </vs-chip>
                                            </div>
                                            <div class="hidden sm:hidden md:hidden lg:hidden">
                                                <label>
                                                    <input type="file" ref="image_files" v-on:change="handleFileUpload()"/>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </vx-card>
                    </vs-tab>
                    <vs-tab :label="$t('Questionario')" :disabled="news_single.translation[0].questions && Object.keys(news_single.translation[0].questions).length == 0">
                        <vx-card>
                            <ul class="polls-list">
                                <li class="poll mb40" v-for="(question, index) in news_single.translation[0].questions" :key="index">
                                    <h5 class="poll-title">{{question.question}}</h5>
                                    <ul class="poll-options-result">
                                        <li class="poll-option mt-3 flex" v-for="(option, key) in question.options" :key="key">
                                            <vs-radio 
                                                v-model="option.answers[0].news_question_option_id" 
                                                :vs-value="option.news_question_option_id"
                                                :vs-name="'quest_'+index" 
                                                :disabled="news_single.translation[0].all_questions_answered"
                                                v-if="question.news_question_type_id == 1">{{option.option_text}}</vs-radio>
                                            <vs-checkbox 
                                                v-else 
                                                :vs-value="option.news_question_option_id"
                                                :disabled="news_single.translation[0].all_questions_answered"
                                                v-model="option.answers[0].news_question_option_id">{{option.option_text}}</vs-checkbox>
                                        </li>
                                    </ul>
                                </li>
                                <vs-button class="mt-5 w-full" @click="questSumbit" v-if="!news_single.translation[0].all_questions_answered">{{$t('submit')}}</vs-button>
                            </ul>
                        </vx-card>
                    </vs-tab>
                </vs-tabs>
            </div>
        </div>
        <vs-row vs-type="flex" vs-justify="center" class="mx-auto mt15" v-if="news_single && Object.keys(news_single).length > 0">
            <router-link :to="{name: 'news-show'}" tag="vs-button">
                <vs-button class="styleButton" color="primary" type="filled" icon-pack="feather" icon="icon-arrow-left">{{$t('Voltar')}}</vs-button>
            </router-link>
        </vs-row>
    </div>
</template>

<script>
    
    import QuillPresentInfo from '@/views/components/QuillPresentInfo.vue'

    export default {
        data(){
            return {
                user: JSON.parse(localStorage.getItem('userSession')),
                news_single: [],
                comment_text: '',
                upload_image: []
            };
        },
        methods: {
            getNewsSingle(){
                const user_info = JSON.parse(localStorage.getItem('userSession'));
                this.$vs.loading();
                this.$api.post( '/myvilagale/news/getNewsSingle?token=' + localStorage.getItem('usertoken'),
                {
                    view: 'news-show-single',
                    news_id: this.$route.params.id,
                    language: this.$i18n.locale.toUpperCase(),
                    user: this.user,
                    is_staff: user_info.is_staff,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
                    }
                })
                .then((res) => {
                    this.$vs.loading.close();
                    if(res.data == ''){
                        this.$router.push({ name: 'news-show'});
                    }else{
                        this.news_single = res.data;
                        this.$emit('change_breadcrumb', { title: res.data.translation[0].titulo, active: true });
                    }
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            },
            darLikeOuDislike(type){
                this.$vs.loading();

                var news_id = this.news_single.id;
                var type_id = type == 'like' ? 1 : 2;
                var vote_id = null;

                if(this.news_single.vote.length > 0){
                    vote_id = this.news_single.vote[0].news_vote_id;
                }

                this.$api.post( '/myvilagale/news/saveVote?token=' + localStorage.getItem('usertoken'),
                {
                    news_id: news_id,
                    type_id: type_id,
                    user_id: this.user.id,
                    vote_id: vote_id
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
                    }
                })
                .then((res) => {
                    this.$vs.loading.close();
                    this.news_single.vote = res.data.vote;
                    this.news_single.likes = res.data.likes;
                    this.news_single.dislikes = res.data.dislikes;
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });

            },

            /*
             * Envia comentario
             */
            sendC() {
                this.$vs.loading();
                let token = localStorage.getItem('usertoken');
                var upload_img = this.upload_image.length == 0 ? null : this.upload_image;

                let formData = new FormData();

                this.buildFormData(formData,  {
                    news_id: this.news_single.id,
                    person_id: this.user.id,
                    comment_text: this.comment_text,
                    reference_id: null,
                    image_file: upload_img,
                    view: 'news-show-single'
                });

                this.$api.post( '/myvilagale/news/saveComment?token=' + token,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then((res) => {
                    this.comment_text = '';
                    this.upload_image = [];
                    this.news_single.comments = res.data;
                    this.$vs.loading.close();
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            },
            addFile(){
                if(this.news_single.length > 0){
                    this.notify('Já chegou ao limite de ficheiros.', 'red');
                    return;
                }
                this.$refs['image_files'].click();
            },
            removeFile(){
                this.upload_image = [];
            },
            handleFileUpload(){
                let uploadedFile = this.$refs['image_files'].files;
                // Tests if the uploaded file has the right extension
                if (/\.(jpe?g|png|gif)$/i.test(uploadedFile[0].name)) {
                    //Adds the uploaded file to the files array
                    this.upload_image.push(uploadedFile[0]);
                } else {
                    this.notify('A imagem tem ser do tipo jpeg, jpg, png ou gif.', 'red');
                }
            },
            buildFormData(formData, data, parentKey) {
                if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                    let that = this;
                    Object.keys(data).forEach(key => {
                        that.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
                    });
                } else {
                    const value = data == null ? '' : data;
                    formData.append(parentKey, value);
                }
            },
            questSumbit(){
                this.$vs.loading();
                this.$api.post( '/myvilagale/news/saveQuestionario?token=' + localStorage.getItem('usertoken'),
                {
                    questionario: this.news_single.translation[0].questions,
                    user: this.user,
                    news_id: this.$route.params.id,
                    language: this.$i18n.locale.toUpperCase()
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
                    }
                })
                .then((res) => {
                    this.news_single.translation[0].questions = res.data.questions;
                    this.news_single.translation[0].all_questions_answered = res.data.all_questions_answered;
                    this.$vs.loading.close();
                    this.notify('Resposta(s) ao questionário registada(s) com sucesso.', 'green');
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            }
        },

        created(){
            this.getNewsSingle();
        },

        watch: {
            '$i18n.locale': function(new_val, old_val){
                this.getNewsSingle();
            }
        },
        components: {
            QuillPresentInfo,
        },
    }
</script>

<style>
    @media only screen and (max-width: 350px) {
        .iconLike{
            margin-right: 2px;
        }
        .iconDislike{
            margin-right: 2px;
        }
        .chip_file{
            padding-bottom: 30px;
        }
        .chip_file .con-vs-chip{
            margin-top: 7px;
        }
    }
    @media only screen and (min-width: 350px) and (max-width: 600px) {
        .break{
            display: block;
        }
        .iconLike{
            margin-right: 5px;
        }
        .iconDislike{
            margin-right: 5px;
        }
        .nrLikeDislike{
            margin-right: 0px;
        }
        .chip_file{
            padding-bottom: 30px;
        }
        .chip_file .con-vs-chip{
            margin-top: 7px;
        }
    }
    @media only screen and (min-width: 600px) {
        .break{
            display: none;
        }
        .iconLike{
            margin-right: 10px;
        }
        .iconDislike{
            margin-right: 10px;
        }
        .nrLikeDislike{
            margin-right: 30px;
        }
    }
    .mt15{
        margin-top: 15px;
    }
    .ml40{
        margin-left: 40px;
    }
    .mr5{
        margin-right: 5px;
    }
    .mr10{
        margin-right: 10px;
    }
    .mr30{
        margin-right: 30px;
    }
    .mb2{
        margin-bottom: 2px;
    }
    .mb5{
        margin-bottom: 5px;
    }
    .mb10{
        margin-bottom: 10px;
    }
    .mb15{
        margin-bottom: 15px;
    }
    .mb40{
        margin-bottom: 40px;
    }
    .pt15{
        padding-top: 15px;
    }
    .pb25{
        padding-bottom: 25px;
    }
    .iconLike{
        color: #4EE44E;
        cursor: pointer;
    }
    .iconDislike{
        color: #ff3232;
        cursor: pointer;
    }
    .nrLikeDislike{
        position: relative;
        bottom: 5px;
    }
    .respostaC{
        margin-left: 20px;
        margin-bottom: 25px!important;
    }
    .videoContainer {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%;
    }
    .video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .comment_image{
        max-height: 150px;
        max-width: 100%;
    }
    .styleButton{
        height: 15px;
    }
    .pre{
        white-space: pre-wrap;
    }
</style>

